import {estadosDeOpcion, opcionesEstadoCliente} from "../pedidos/estados-pedido-cliente";

/**
 * El Estado de los diseños (solicitudes) «como los ve el cliente», en un solo sitio para que lo que se ve y lo que se
 * filtra no se separen: sin pedido, la columna enseña el estado de la solicitud en mayúsculas; con pedido, la píldora
 * del pedido («PEDIDO 123 · EN PRODUCCIÓN», ver pages/solicitudes/estado-solicitud.ts). El filtro de Estado ofrece esos
 * textos (sin el «PEDIDO 123 ·») y EstadoSolicitudClienteFilter manda a la API los estados reales de cada lado
 * (EstadoSolicitudClienteFilter de cnc-api los junta con O). Vive fuera del modelo para no importarlo desde el filtro
 * (el modelo usa el filtro en su decorador y el import circular lo dejaría sin definir).
 */

/** Los estados reales de una solicitud (valores de EstadoSolicitud en cnc-api) */
export const ESTADOS_SOLICITUD = {
    EN_CURSO: "Solicitud en curso",
    REALIZADO: "Solicitud realizada",
    RECHAZADO: "Solicitud rechazada",
    EN_DISENO: "En diseño",
    PENDIENTE_VALIDAR: "Pendiente de validación",
    A_REVISAR: "Diseño en revisión",
    VALIDADO: "Diseño validado"
};

/** Lo que pide a la API una opción del filtro: los estados reales de cada lado */
export interface EstadosDeOpcionSolicitud {
    solicitud: string[];
    pedido: string[];
}

const textoDeSolicitud = (estado: string) => estado.toUpperCase();

/**
 * Las opciones del filtro: los textos de la solicitud (en el orden de ESTADOS_SOLICITUD) y después los del pedido
 * (las opciones del Estado de Pedidos, que ya dejan fuera PENDIENTE DE VALIDACIÓN, VALIDADO, CANCELADO y PAUSADO); un
 * texto que salga por los dos lados, una sola vez.
 */
export function opcionesEstadoSolicitudCliente(): string[] {
    const opciones = Object.values(ESTADOS_SOLICITUD).map(textoDeSolicitud);
    for (const opcion of opcionesEstadoCliente()) {
        if (!opciones.includes(opcion)) {
            opciones.push(opcion);
        }
    }
    return opciones;
}

/** Los estados reales que se ven como `opcion`, de cada lado (un texto que no es opción no pide nada) */
export function estadosDeOpcionSolicitud(opcion: string): EstadosDeOpcionSolicitud {
    return {
        solicitud: Object.values(ESTADOS_SOLICITUD).filter(e => textoDeSolicitud(e) === opcion),
        pedido: estadosDeOpcion(opcion),
    };
}
